import { ATTENTION_STATUS_ROLE_IDS } from 'partner360/entities/attentionStatuses'

import type { TCockpitAttentionGrouping } from '../../model/types'

export interface IAttentionGroupingAccess {
  /** Groupings the role may pick, in the order the switcher lists them. */
  options: TCockpitAttentionGrouping[]
  defaultGrouping: TCockpitAttentionGrouping
}

/** A PBM works inside their own partners, so there is nothing to group them by. */
const PBM_ACCESS: IAttentionGroupingAccess = {
  options: ['partner'],
  defaultGrouping: 'partner',
}

const MANAGER_ACCESS: IAttentionGroupingAccess = {
  options: ['pbm', 'market', 'partner'],
  defaultGrouping: 'pbm',
}

/** Geo leads, and anyone the cockpit does not name a role for. */
const GEO_ACCESS: IAttentionGroupingAccess = {
  options: ['market', 'pbm', 'manager', 'partner'],
  defaultGrouping: 'market',
}

export const getAttentionGroupingAccess = (roleId?: string | null): IAttentionGroupingAccess => {
  switch (roleId) {
    case ATTENTION_STATUS_ROLE_IDS.pbm:
      return PBM_ACCESS
    case ATTENTION_STATUS_ROLE_IDS.manager:
      return MANAGER_ACCESS
    case ATTENTION_STATUS_ROLE_IDS.geoLead:
    default:
      return GEO_ACCESS
  }
}
